import { useState } from "react";
import { Button, Col, ListGroup, Row, Stack } from "react-bootstrap";
import useSortableData from "../useSortableData";
import { ArrowRight, HeartbreakFill, PencilFill } from "react-bootstrap-icons";
import SongSearchModal from "../SongSearchModal";

export default function PlaylistAutopilotImportSongMatching({ data, setData }) {
    const missingSongsCount = data.songs.filter(x => !x.matched).length;
    const { sortedItems } = useSortableData(data.songs, { key: "similarity", direction: "ascending" });

    const handleMatchedSongChange = (newSong, originalSongId) => {
        setData(current => ({
            ...current,
            songs: current.songs.map(song => (song.original.song_id === originalSongId ? { ...song, matched: newSong } : song)),
        }));
    };

    return (
        <>
            <Col>
                <h4 className="text-uppercase">Automatic matching</h4>
                <Stack>
                    <span>
                        Total: <span className="fw-bold">{data.songs.length}</span> songs
                    </span>
                    <span>
                        Matched by song ID: <span className="fw-bold">{data.matched_by_song_id}</span>
                    </span>
                    <span>
                        Matched by RA song ID: <span className="fw-bold">{data.matched_by_item_id}</span>
                    </span>
                    <span>
                        Matched by artist and title: <span className="fw-bold">{data.matched_by_artist_title}</span>
                    </span>
                    <span>
                        Not matched: <span className="fw-bold">{data.not_matched}</span>
                    </span>
                </Stack>
            </Col>
            <Col className="d-flex flex-column mt-3">
                <h4 className="text-uppercase">Manual matching</h4>
                <span>Please match the incorrect songs with the edit button</span>
                <span>
                    Not matched left: <span className="fw-bold">{missingSongsCount}</span>
                </span>
                <div className=" overflow-y-auto">
                    <ListGroup as={"ul"}>
                        {sortedItems.map(x => (
                            <SongMatchRow key={x.original.song_id} songMatch={x} onMatchedSongChange={handleMatchedSongChange} />
                        ))}
                    </ListGroup>
                </div>
            </Col>
        </>
    );
}

function SongMatchRow({ songMatch, onMatchedSongChange }) {
    const [showModal, setShowModal] = useState(false);

    return (
        <ListGroup.Item as={"li"} className={`border-dark bg-success-subtle ${!songMatch.matched && "bg-danger-subtle"}`}>
            <Row className=" align-items-center">
                <Col>
                    <span>
                        {songMatch.original.artist} - {songMatch.original.title}
                        {songMatch.original.release_year && <span> ({songMatch.original.release_year})</span>}
                    </span>
                </Col>
                <Col xs="auto">
                    <ArrowRight height={25} width={25} />
                </Col>
                <Col>
                    {songMatch.matched ? (
                        <span>
                            {songMatch.matched.artist} - {songMatch.matched.title}
                            {songMatch.matched.release_year && <span> ({songMatch.matched.release_year})</span>}
                        </span>
                    ) : (
                        <span>No match found</span>
                    )}
                </Col>
                <Col xs="auto">
                    <Stack direction="horizontal" gap={1}>
                        <Button size="sm" variant="primary" title={"Edit"} className=" btn-ra-yellow bordered" onClick={() => setShowModal(true)}>
                            <PencilFill />
                        </Button>
                        <Button size="sm" variant="danger" title={"Remove Match"} onClick={() => onMatchedSongChange(null, songMatch.original.song_id)}>
                            <HeartbreakFill />
                        </Button>
                    </Stack>
                </Col>
            </Row>
            <SongSearchModal
                show={showModal}
                title={`${songMatch.original.artist} - ${songMatch.original.title}`}
                handleClose={() => setShowModal(false)}
                onConfirm={newSong => onMatchedSongChange(newSong, songMatch.original.song_id)}
                defaultArtist={songMatch.original.artist}
                defaultTitle={songMatch.original.title}
            />
        </ListGroup.Item>
    );
}
